import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc,
  query,
  orderBy,
  where,
  serverTimestamp 
} from 'firebase/firestore'
import { db } from '@/firebase/config'

export class ExerciseService {
  constructor(userId) {
    this.userId = userId
    this.exercisesRef = collection(db, 'users', userId, 'exercises')
  }

  // Add new exercise
  async addExercise(exerciseData) {
    try {
      const docRef = await addDoc(this.exercisesRef, {
        ...exerciseData,
        completed: false,
        createdAt: serverTimestamp()
      })
      return { success: true, id: docRef.id }
    } catch (error) {
      console.error('Error adding exercise:', error)
      return { success: false, error: error.message }
    }
  }

  // Get all exercises
  async getExercises() {
    try {
      const q = query(this.exercisesRef, orderBy('createdAt', 'desc'))
      const querySnapshot = await getDocs(q)
      const exercises = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        exercises.push({
          id: doc.id,
          ...data,
          // Convert Timestamp to string
          createdAt: data.createdAt?.toDate().toISOString(),
          completedAt: data.completedAt?.toDate().toISOString()
        })
      })
      return { success: true, exercises }
    } catch (error) {
      console.error('Error getting exercises:', error)
      return { success: false, error: error.message, exercises: [] }
    }
  }

  // Complete exercise
  async completeExercise(exerciseId) {
    try {
      const exerciseDoc = doc(db, 'users', this.userId, 'exercises', exerciseId)
      await updateDoc(exerciseDoc, {
        completed: true,
        completedAt: serverTimestamp()
      })
      return { success: true }
    } catch (error) {
      console.error('Error completing exercise:', error)
      return { success: false, error: error.message }
    }
  }

  // Uncomplete exercise
  async uncompleteExercise(exerciseId) {
    try {
      const exerciseDoc = doc(db, 'users', this.userId, 'exercises', exerciseId)
      await updateDoc(exerciseDoc, {
        completed: false,
        completedAt: null
      })
      return { success: true }
    } catch (error) {
      console.error('Error uncompleting exercise:', error)
      return { success: false, error: error.message }
    }
  }

  // Update exercise
  async updateExercise(exerciseId, updates) {
    try {
      const exerciseDoc = doc(db, 'users', this.userId, 'exercises', exerciseId)
      await updateDoc(exerciseDoc, updates)
      return { success: true }
    } catch (error) {
      console.error('Error updating exercise:', error)
      return { success: false, error: error.message }
    }
  }

  // Delete exercise
  async deleteExercise(exerciseId) {
    try {
      const exerciseDoc = doc(db, 'users', this.userId, 'exercises', exerciseId)
      await deleteDoc(exerciseDoc)
      return { success: true }
    } catch (error) {
      console.error('Error deleting exercise:', error)
      return { success: false, error: error.message }
    }
  }

  // Get weekly completed exercises
  async getWeeklyCompletedExercises() {
    try {
      const now = new Date()
      const weekStart = new Date(now.setDate(now.getDate() - now.getDay()))
      weekStart.setHours(0, 0, 0, 0)

      const q = query(
        this.exercisesRef,
        where('completed', '==', true),
        where('completedAt', '>=', weekStart)
      )
      
      const querySnapshot = await getDocs(q)
      const exercises = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        exercises.push({
          id: doc.id,
          ...data,
          completedAt: data.completedAt?.toDate().toISOString()
        })
      })
      
      return { success: true, exercises }
    } catch (error) {
      console.error('Error getting weekly exercises:', error)
      return { success: false, error: error.message, exercises: [] }
    }
  }
}